<script setup lang="ts">
import ReportProblemForm from "~/components/ReportProblem/Form.client.vue";

const props = defineProps({
  isConsolidated: {
    type: Boolean,
    default: false,
  },
});

const showFeedback = () => {
  const { open, close } = useDialog({
    title: "Feedback",
    component: ReportProblemForm,
    props: {
      type: "feedback",
      onClose: () => {
        close();
      },
    },
  });

  open();
};
</script>

<template>
  <BaseTextButton v-tooltip="'Feedback'" @click="showFeedback" color="primary">
    <icon name="icon-park-outline:email-push" size="25" />
  </BaseTextButton>
</template>

<style scoped></style>
